module.exports = __webpack_public_path__ + "asset/image-Wrench-69bb56c7a8d91d6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Wrench.svg
// module id = YwHZ
// module chunks = 0